// extracted by mini-css-extract-plugin
module.exports = {"button":"modal-button_button__3Stka","wrapper":"modal-button_wrapper__2ZSnh","gray":"modal-button_gray__l9lCT"};